<template>
  <div>
    <v-card-text class="pa-0" style="height: 600px; overflow-y: auto;">
      <v-layout class="pa-2" row wrap style="height: auto;" v-if="device">    
        <v-flex xs12>
      <v-treeview dark
        :items="tree"
        item-children="sub_devices"
        open-all
      >
        
        <template v-slot:label="{ item, active }">
          <v-chip small>{{item.identifier}}</v-chip>
          <v-chip small>{{get_type_title(item.type)}}</v-chip>
          <v-chip small>{{get_content_model(item.form_data.model, "name")}}</v-chip>
        </template>

      </v-treeview>
    </v-flex>

<!--        <template v-for="[subdevice,ctx] in tree">
          {{subdevice.identifier}} {{ctx.depth}}
        </template>-->
      </v-layout>
    </v-card-text>

    <v-card-actions style="background-color: #3A3A3A; min-height: 85px;">
    </v-card-actions>
  </div>
</template>

<script>
import SettingsModel from '@/models/settings.js';

export default {
  props: ["id"],
  data() {
    return {
    }
  },
  computed: {
    device () {
      return this.$store.state.devices[this.id];
    },
    tree () {
      var ret = [];
      var self = this;
      var parent = this.find_parent(self.device);
      parent.sub_devices = this.get_subdevices(parent);
      return [parent];
    },

  },
  methods: {
    get_device(id) {
      return this.$store.state.devices[id];
    },

    get_subdevices(item) {
      var self = this;
      var subdevices = _.map(item.sub_device_list, function(id) {
        var device = self.get_device(id);
        device.sub_devices = self.get_subdevices(device);
        return device;
      });
      return _.filter(subdevices, (device) => { return !_.get(device, ["meta", "multiple_parents_subdevice"], false); });
    },

    find_parent(item) {
      var parent = this.get_parent(item);
      if (typeof(parent) == "undefined") return item;
      return this.find_parent(parent);
    },

    get_parent(item) {
      var id = item.id;
      var parents = _.filter(this.$store.state.devices, function(device) {
        if (device.sub_device_list.includes(id)) return true;
      });
      if (parents.length == 1) return parents[0];
      return undefined;
    },

    get_type_title(type) {
      var setting = SettingsModel.get_by_name(type);
      if (typeof(setting) != "undefined") {
        return setting.title || type;
      }
      return type;
    },

     get_content_model(field, name) {
      if (typeof(field) != "undefined" && field != null) {
        return field[name];
      }
      return "";
    },
    get_content(field, name) {
      if (typeof(field) != "undefined") {
        return field[name];
      }
      return "";
    }
  }
}
</script>